export default __webpack_public_path__ + "static/media/bike-5.0347bde8.svg";